module.exports = __webpack_public_path__ + "static/media/logo_icon_gold.06ff4064.svg";